import { ModelBase } from 'store/model-base';

export class CmsNowDeviceDetails extends ModelBase {
    public static storeName: string = 'cmsNowDeviceDetails';
    public deviceBridge: CmsNowDeviceBridge;
    public deviceDetails: CmsNowDeviceLink;
    public manageDevice: CmsNowManageDevice;
}
